// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimeBadge_wrapper___Pr2a","completed":"TimeBadge_completed__d4YZC","overdue":"TimeBadge_overdue__SUNqs","icon":"TimeBadge_icon__wZPlJ"};